import { useEffect, useReducer, useState } from "react";
import { useStudentRegisterMutation } from "../../features/auth/authApi";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";

export default function SignupForm() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const initialValue = {
    name:'',
    email:'',
    password:'',
    confirmPassword:'',
  }

  const [data,setData] = useReducer((prev,next)=>{
    return {...prev,...next}
  },initialValue)



  const [signup, { data:user, isLoading, error:signupError, isSuccess, isError }] = useStudentRegisterMutation();

  useEffect(() => {
    if(isSuccess && error!==''){
      navigate('/course')
    }
    
  }, [isSuccess, navigate, error]);

  useEffect(()=>{
    if(signupError?.data!==''){
      setError(signupError?.data)
    }else{
      setError('')
    }
  },[signupError])

  const submitHandler = (e) => {
    e.preventDefault();
    setError('');

    // if(data?.password?.length < 4 ){
    //   setError('Password must be at least 4 digits ')
    // }
    if(data?.password !== data?.confirmPassword){
      setError('Password and confirm password not matched!')
      return;
    }

    const body ={
      name:data?.name,
      email:data?.email,
      role:'student',
      password:data?.password
    }
    signup({...body})   
  }

  const inputChangeHandler = (e, name) => {
    setError('')
    setData({[name]:e.target.value})
  }

  return (
    <form className="mt-8 space-y-6" onSubmit={submitHandler}>
      <input  type="hidden" name="remember" value="true" />
      <div className="rounded-md shadow-sm -space-y-px">
        <div>
          <label htmlFor="name" className="sr-only">Name</label>
          <input value={data?.name} onChange={e=>inputChangeHandler(e,'name')} id="name" name="name" type="name" autoComplete="name" required
            className="login-input rounded-t-md" placeholder="Student Name" />
        </div>
        <div>
          <label htmlFor="email-address" className="sr-only">Email address</label>
          <input value={data?.email} onChange={e=>inputChangeHandler(e,'email')} id="email-address" name="email" type="email" autoComplete="email" required
            className="login-input " placeholder="Email address" />
        </div>
        <div>
          <label htmlFor="password" className="sr-only">Password</label>
          <input value={data?.password} onChange={e=>inputChangeHandler(e,'password')} id="password" name="password" type="password" autoComplete="current-password" required
            className="login-input" placeholder="Password" />
        </div>
        <div>
          <label htmlFor="confirm-password" className="sr-only">Confirm Password</label>
          <input value={data?.confirmPassword} onChange={e=>inputChangeHandler(e,'confirmPassword')} id="confirm-password" name="confirm-password" type="password"
            autoComplete="confirm-password" required className="login-input rounded-b-md"
            placeholder="Confirm Password" />
        </div>
      </div>

      <div className="text-red-600 text-center w-full">{error}</div> 

      <div>
        <button type="submit" disabled={isLoading}
          className="group relative cursor-pointer w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
          Create Account
          {isLoading && <span className="absolute left-0 top-0 h-full w-full" > <LoadingOutlined/> </span> }
        </button>
      </div>
    </form>
  )
}